// extracted by mini-css-extract-plugin
export var alignCenter = "_74-d";
export var bannerShown = "_74-6";
export var buttonContent = "_74-0";
export var cardList = "_74-1";
export var centerContent = "_74-2";
export var chevron = "_74-3";
export var closePanelButton = "_74-k";
export var conversationContextContainer = "_74-l";
export var conversationDetailContainer = "_74-4";
export var detailWrapper = "_74-7";
export var dropdownButton = "_74-e";
export var dropdownTitle = "_74-9";
export var fullHeight = "_74-5";
export var hidden = "_74-a";
export var icon = "_74-b";
export var mergeSuggestionWrapper = "_74-m";
export var panel = "_74-i";
export var portalButtonsWrapper = "_74-c";
export var right = "_74-j";
export var tableSummaryContainer = "_74-8";
export var tableSummaryHeader = "_74-g";
export var threeDotsButton = "_74-f";
export var wide = "_74-h";